<script>
import headNav from '../../src/components/headNav.vue'
import {Balancepayment, getRentDetail, payOrder} from "../api/api";
import {mapGetters} from "vuex";
export default {
  name: "home",
  components:{headNav},
  computed:{
    ...mapGetters(['userInfo'])
  },
  data(){
    return{
      numberText:'',
      arr:[
        '11111','222222','33333'
      ],
      pathText:'6666666',
      payArr:[
        {
            price:'',
            day:'Period 30 day'
        },
      ],
      indexModule:0,
      phone:null,
      price:null,
      orderNo:null,
      dialogVisible:false,
    }
  },

  mounted() {
    this.price = this.$route.query.price
    this.phone = this.$route.query.phone
    this.payArr[0].price = `$${this.price}`
  },
  methods:{
    mes(message,type){
      this.$message({
        message,
        type
      });
    },
    pay(){
      payOrder({
        days:30,
        id: this.userInfo.id,
        price:this.price,
        phone: this.phone
      }).then(res => {
        console.log(res,'打印res')
        console.log("进来了")
        if(res.data.status != 200){
          this.mes(res.data.data.message,'error')
          return
        }
        this.orderNo = res.data.data.order_no
        this.dialogVisible = true

      })
    },
    getMapping(list,num) {
      let len = list.length
      let newList = []
      if (len) {
        var chunk = num
        for (var i = 0, j = len; i < j; i += chunk) {
          newList.push(list.slice(i, i + chunk))
        }
      }
      console.log(newList,'打印分组后的数组')
      return newList
    },
    onCopy() {
      this.$copyText(this.phone).then(
        e=>{
          console.log('复制成功：', e);
          this.$message({
            message: 'copied',
            type:'success'
          });
        },
        e=>{
          console.log('复制失败：', e);
        }
      )
    },
    moduleClick(e,idx){
        this.indexModule = idx
    },
    //余额支付
    balancePay(){
      Balancepayment({
        id:this.userInfo.id,
        order_id:this.orderNo
      }).then( res => {
        console.log(res,"打印res")
      })
    }
  }

}
</script>

<template>
  <div style="background: rgb(241 241 241);height:1000px">
<!--    <head-nav></head-nav>-->
    <b-container class="ok" fluid style="margin-bottom: 30px;margin-top: 30px">
        <b-row>
        <div class="headText">Order summary</div>
        </b-row>
    </b-container>
    <b-container class="ok"  fluid style="margin-bottom: 30px;margin-top: 30px;">
      <b-row style="background:#FFFFFF;border-radius:10px;padding:20px">
        <b-col>
          <b-row>
            <b-col sm="8">
                <img src="../../static/1.png" style="width:100px;height:60px" alt="">
                <div style="display:inline-block;color:#2080E4;margin-left:30px">+384782342934972</div>
            </b-col>

            <b-col sm="4" style="padding:20px 0;box-sizing:border-box">
                <img src="../../static/copy.png" @click="onCopy()" style="width:20px;heigth:20px" alt="">
            </b-col>
          </b-row>
          <b-row style="margin-top:20px">
            <b-col sm="6" v-for="(item,index) in payArr" :key="index">
                <div @click="moduleClick(item,index)" :class="index == indexModule ? 'module1' : 'module2'">
                    <div>{{item.price}}</div>
                    <div>{{item.day}}</div>
                </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button block variant="primary" @click="pay">payment</b-button>
            </b-col>
            <b-col>

            </b-col>

          </b-row>
        </b-col>


        <b-col>

        </b-col>
      </b-row>

    </b-container>
    <el-dialog
      title="Choose payment method"
      :visible.sync="dialogVisible"
      width="30%">
      <div style="">
<!--          <div>-->
<!--            <form action="https://www.coinpayments.net/index.php" method="post" target="_top">-->
<!--              <input type="hidden" name="cmd" value="_pay_simple">-->
<!--              <input type="hidden" name="item_number" :value="orderNo">-->
<!--              <input type="hidden" name="reset" value="1">-->
<!--              <input type="hidden" name="merchant" value="3bf9f9f8b9d9c74b387a3fa6339f5dd8">-->
<!--              <input type="hidden" name="currency" value="LTC">-->
<!--              <input type="hidden" name="amountf" :value="price">-->
<!--              <input type="hidden" name="item_name" :value="phone">-->
<!--              <input type="hidden" name="success_url" value="https://freerealnumber.com/#/success">-->
<!--              <input type="hidden" name="cancel_url" value="https://freerealnumber.com/#/cancel">-->
<!--              <input type="image" src="https://www.coinpayments.net/images/pub/buynow-grey.png" alt="现在就购买CoinPayments.net">-->
<!--            </form>-->
<!--          </div>-->
          <div>
            <b-button block variant="primary" @click="balancePay">Balance payment</b-button>
          </div>
      </div>

      <span slot="footer" class="dialog-footer">
  </span>
    </el-dialog>
  </div>
</template>

<style scoped>
.module1{
    border:1px solid #11AB69;
    padding: 15px 20px;
    box-sizing: border-box;
    border-radius: 5px;
    margin-bottom: 20px;
    text-align: center;
    background: rgba(17,171,105,0.05);
    cursor: pointer;
}
.module2{
    border:1px solid #dbdddc;
    padding: 15px 20px;
    box-sizing: border-box;
    border-radius: 5px;
    margin-bottom: 20px;
    text-align: center;
    cursor: pointer;
}
.module2:hover{
    background: rgba(17,171,105,0.05);
}
body{
    background: rgb(217, 215, 215);
}
@media screen and (min-width: 900px) {
  .ok>.row{
    margin-left: 200px;
    margin-right: 200px;

  }
}
.headText{
    font-weight: bold;
    font-size:26px;
    margin:20px 0
}
</style>



// WEBPACK FOOTER //
// src/view/rentPrivateDetail.vue